import React, { useState } from "react";
import "../CSS/School_reg.css";
import { useNavigate } from "react-router-dom";

function School_reg() {
  const [step, setStep] = useState("confirm");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

    const navigate = useNavigate();

     const handleNavigation = (destination) => {
        //const username = Cookies.get("userID");
    
  
        navigate(`/${destination}`);
      };
    

  const handleProceed = () => {
    setStep("code");
    setError("");
  };

  const handleCancel = () => {
    setStep("cancelled");
  };

  const handleCodeChange = (e) => {
    // Allow numbers only and limit to 6 digits
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(value);
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (code.length !== 6) {
      setError("Please enter a valid 6-digit code.");
      return;
    }

    // Replace this with your actual portal verification logic
    alert("Code accepted. Proceeding to the school portal...");
    handleNavigation('ei')

    // Example:
    // window.location.href = "/school-portal";
  };

  return (
    <div className="page">
      <div className="portal-card">

        {step === "confirm" && (
          <>
            <div className="icon">🎓</div>

            <h1>EI</h1>

            <p className="question">
              Would you like to proceed to this portal?
            </p>

            <p className="description">
              Access restricted to only authorised educational institutions.
            </p>

            <div className="button-group">
              <button
                className="btn btn-primary"
                onClick={handleProceed}
              >
                Yes, Proceed
              </button>

              <button
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </>
        )}

        {step === "code" && (
          <>
            <div className="icon">🔐</div>

            <h1>Enter Access Code</h1>

            <p className="description">
              Enter the six-digit code provided to you to continue
              to the school portal.
            </p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                inputMode="numeric"
                maxLength="6"
                value={code}
                onChange={handleCodeChange}
                placeholder="000000"
                className="code-input"
                autoFocus
              />

              {error && (
                <p className="error">
                  {error}
                </p>
              )}

              <button
                type="submit"
                className="btn btn-primary full-width"
              >
                Continue to Portal
              </button>
            </form>

            <button
              className="back-button"
              onClick={() => {
                setStep("confirm");
                setCode("");
                setError("");
              }}
            >
              ← Go Back
            </button>
          </>
        )}

        {step === "cancelled" && (
          <>
            <div className="icon">👋</div>

            <h1>Access Cancelled</h1>

            <p className="description">
              You have chosen not to proceed to the school portal.
            </p>

            <button
              className="btn btn-primary full-width"
              onClick={() => setStep("confirm")}
            >
              Return
            </button>
          </>
        )}

      </div>
    </div>
  );
}

export default School_reg;